import { Router } from 'framework7/types';
import { CheckInCarConditionPage } from '@/components/pages/BodyAndPaint/CheckInCarConditionPage';
import { CheckInReserveConfirmPage } from '@/components/pages/BodyAndPaint/CheckInReserveConfirmPage';
import { CheckInReserveDatePage } from '@/components/pages/BodyAndPaint/CheckInReserveDatePage';
import { CheckInUseInsurancePage } from '@/components/pages/BodyAndPaint/CheckInUseInsurancePage';
import { CheckInUseLoanerCarPage } from '@/components/pages/BodyAndPaint/CheckInUseLoanerCarPage';
import { RepairDamagedImagePage } from '@/components/pages/BodyAndPaint/RepairDamagedImagePage';
import { RepairEstimateResultPage } from '@/components/pages/BodyAndPaint/RepairEstimateResultPage';
import { RepairImageCheckPage } from '@/components/pages/BodyAndPaint/RepairImageCheckPage';
import { RepairInfoDetailPage } from '@/components/pages/BodyAndPaint/RepairInfoDetailPage';
import { RepairItemRequestPage } from '@/components/pages/BodyAndPaint/RepairItemRequestPage';
import { RepairItemSelectPage } from '@/components/pages/BodyAndPaint/RepairItemSelectPage';
import { RepairPickUpConfirmPage } from '@/components/pages/BodyAndPaint/RepairPickUpConfirmPage';
import { RepairPickUpReservePage } from '@/components/pages/BodyAndPaint/RepairPickUpReservePage';
import { RepairProcessImagePage } from '@/components/pages/BodyAndPaint/RepairProcessImagePage';
import { paths } from '@/config/paths';

export const bodyAndPaintRoutes: Router.RouteParameters[] = [
  {
    path: paths.bpsCheckInCarCondition,
    name: '入庫予約車の状態',
    component: CheckInCarConditionPage,
  },
  {
    path: paths.bpsCheckInUseInsurance,
    name: '入庫予約保険利用',
    component: CheckInUseInsurancePage,
  },
  {
    path: paths.bpsCheckInReserveDate,
    name: '入庫予約入庫日予約',
    component: CheckInReserveDatePage,
  },
  {
    path: paths.bpsCheckInUseLoanerCar,
    name: '入庫予約代車利用',
    component: CheckInUseLoanerCarPage,
  },
  {
    path: paths.bpsCheckInReserveConfirm,
    name: '入庫予約予約確認',
    component: CheckInReserveConfirmPage,
  },
  {
    path: paths.bpsRepairInfoDetail,
    name: '予約詳細',
    component: RepairInfoDetailPage,
  },
  {
    path: paths.bpsRepairImageCheck,
    name: '修理画像の確認',
    component: RepairImageCheckPage,
  },
  {
    path: paths.bpsRepairProcessImage,
    name: '修理の工程',
    component: RepairProcessImagePage,
  },
  {
    path: paths.bpsRepairPickUpReserve,
    name: '納車返却日予約',
    component: RepairPickUpReservePage,
  },
  {
    path: paths.bpsRepairPickUpConfirm,
    name: '納車返却日予約確認Í',
    component: RepairPickUpConfirmPage,
  },
  {
    path: paths.bpsRepairEstimateResult,
    name: '傷・凹み修理見積もり結果',
    component: RepairEstimateResultPage,
  },
  {
    path: paths.bpsRepairDamagedImage,
    name: '損傷画像の確認',
    component: RepairDamagedImagePage,
  },
  {
    path: paths.bpsRepairItemSelect,
    name: '整備項目選択',
    component: RepairItemSelectPage,
  },
  {
    path: paths.bpsRepairItemRequest,
    name: '依頼確認',
    component: RepairItemRequestPage,
  },
];
